import script from "./CollapsedContent.vue?vue&type=script&setup=true&lang=js"
export * from "./CollapsedContent.vue?vue&type=script&setup=true&lang=js"

import "./CollapsedContent.vue?vue&type=style&index=0&id=548ab656&scoped=true&lang=css"

import exportComponent from "/home/runner/work/HexaHome/HexaHome/node_modules/.pnpm/vue-loader@17.0.1_vue@3.2.45_webpack@5.75.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-548ab656"]])

export default __exports__